import React from "react";

const Academic = () => {
  // Replace this with your actual Google Drive file ID
  const fileId = "1eENjYSrJrTbO1-V51LCAqoatq8qojqJj"; // Example ID

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center">
      <div className="bg bg-opacity-90 rounded-lg shadow-lg max-w-5xl w-full text-center p-6">
        <br />
        <h1 className="text-2xl font-bold mb-4 text-white-800">
          Academic Schedule B.E / B.Tech / M.E / M.Tech / MCA / MBA
        </h1>

        <br />
         
        {fileId ? (
          <div className="w-full aspect-video">
            <iframe
              title="Academic Schedule PDF"
              src={`https://drive.google.com/file/d/${fileId}/preview`}
              width="100%"
              height="600"
              allow="autoplay"
              className="rounded-lg shadow-lg"
            ></iframe>
          </div>
        ) : (
          <p className="text-gray-700 font-semibold">
            Academic schedule will be updated soon.
          </p>
        )}
      </div>
    </div>
  );
};

export default Academic;
